import * as React from 'react';

const CalendarAddFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="calendar-add-fill_svg__24_small_calendar_add_fill-a"
                d="M10.5 12.5V10h-1v2.5H7v1h2.5V16h1v-2.5H13v-1h-2.5zM14 0h1v2h5v4H0V2h5V0h1v2h8V0zM0 20V7h20v13H0z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask
                id="calendar-add-fill_svg__24_small_calendar_add_fill-b"
                fill="#fff"
            >
                <use xlinkHref="#calendar-add-fill_svg__24_small_calendar_add_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#calendar-add-fill_svg__24_small_calendar_add_fill-a"
            />
            <g mask="url(#calendar-add-fill_svg__24_small_calendar_add_fill-b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CalendarAddFillSvg.displayName = 'CalendarAddFillSvg';
export default CalendarAddFillSvg;
